module.exports = __webpack_public_path__ + "static/media/banner_homework_report.ff7c4770.png";